import { useCollectionData } from "react-firebase-hooks/firestore";
import { collection, query } from "firebase/firestore";
import { db } from "@poseidon/firebase";
import { withIdConverter } from "@poseidon/firebase/converters/with-id";

export function useSettlementFigures(agreementId) {
  const [settlementFigures, loading, error] = useCollectionData(
    query(
      collection(db, `agreements/${agreementId}/settlementFigures`)
    ).withConverter(withIdConverter)
  );
  return { settlementFigures, loading, error };
}
